<template>
  <v-container
    class="pa-0 mt-md-2"
  >
    <v-toolbar
      flat
    >
      <v-btn
        icon
        to="/eleave/list"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $t('eLeave.AllAppliedAbsent') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="approvedAbsents"
      :footer-props="{
        disableItemsPerPage: true
      }"
      class="v-data-footer__select-hide v-data-table--sm-dense"
      @click:row="goToDetailPage"
    >
      <template v-slot:item.appStatus="{ item }">
        <span :class="appStatusClass(item)">
          {{ $t(item.appStatus) }}
        </span>
      </template>
      <template v-slot:item.refFormCode="{ item }">
        <v-btn
          v-if="$config.isBrowser && showDownloadButton(item.refFormCode)"
          icon
          large
          class="float-right"
          :loading="downloadLoading"
          @click.stop="downloadFile(item.refFormCode)"
        >
          <v-icon color="deep-orange lighten-2">
            {{ mdiFileDownloadOutline }}
          </v-icon>
        </v-btn>
        <v-tooltip
          top
          color="black"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="item.refFormCode && item.attachments.length > 0 && $config.isBrowser"
              icon
              large
              class="float-right"
              v-bind="attrs"
              v-on="on"
              @click.stop="downloadELeaveAttachments(item.refFormCode)"
            >
              <v-icon color="grey darken-3">
                {{ mdiFileDownloadOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Outbox.Attachment') }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn
          text
          icon
          class="d-none d-md-inline-flex"
        >
          <v-icon
            v-if="item.details"
            @click="goToDetailPage(item)"
          >
            {{ mdiChevronRight }}
          </v-icon>
        </v-btn>

        <v-btn
          v-if="item.details"
          depressed
          small
          class="d-md-none"
          @click="goToDetailPage(item)"
        >
          {{ $t('eLeave.Detail') }}
        </v-btn>
      </template>
    </v-data-table>
    <span class="text-caption grey--text">{{ $t('eLeave.RecentXYearRecords', {'0': '2'}) }}</span>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { eLeaveModule } from '../../store/moduleName'
import { appStatusClassMixin } from './mixins/appStatusClassMixin'
import { mdiArrowLeft, mdiChevronRight, mdiFileDownloadOutline } from '@mdi/js'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'

export default {
  components: {
  },
  mixins: [appStatusClassMixin, eLeaveMethod],
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      mdiChevronRight: mdiChevronRight,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      headers: [
        {
          text: this.$t('eLeave.appStatus'),
          value: this.$chPtField('chinAbsentTypeDesc')
        },
        {
          text: this.$t('Text.Date'),
          value: 'period'
        },
        {
          text: this.$t('Text.NumberOfDays'),
          value: 'numDaysManual'
        },
        {
          text: this.$t('Text.Status'),
          value: 'appStatus'
        },
        {
          text: '',
          value: 'refFormCode'
        },
        {
          text: null,
          value: 'action',
          sortable: false,
          align: 'right'
        }
      ],
      downloadLoading: false
      // approvedLeaves: [
      //   {
      //     date: '2019-10-25 ~ 2019-10-25',
      //     days: 1,
      //     leaveType: '年假',
      //     status: '批淮'
      //   },
      //   {
      //     date: '2019-10-12 ~ 2019-10-22',
      //     days: 10,
      //     leaveType: '長年假',
      //     status: '取消'
      //   }
      // ]
    }
  },
  computed: {
    ...mapState({
      approvedAbsents: state => state[eLeaveModule].faltasRecords
    })
  },
  created () {
    this.$store.dispatch(eLeaveModule + '/getFaltasRecords', 1) // get the records of current year and previous year
    // this.$store.dispatch(eLeaveModule + '/getFaltasRecordsThisYear')
    // this.$store.dispatch(coursesModule + '/getProposalFormReportByYear', ~~year)
    // this.getProposalByYear(year)
  },
  methods: {
    goToDetailPage: function (item) {
      if (item.details) {
        this.$router.push({ name: 'ApprovedAbsentDetail', params: { absentRecord: item } })
      }
      // alert(item.details[0].startDate)
    }
  }
}
</script>
